import React from 'react';
import { closeButtonStyle, closeButtonWebExtra } from './styles';
import { MCButton } from 'components/basic';
import { BASE_ICONS } from 'components/svg';

// Small "x" button to remove a file.
// Template 1: absolute overlay in the corner (scss: .mc-file-box__close { position: absolute; ... }).
// Template 2: no overlay override in scss for this template, so it sits inline
// at the end of the row instead of floating over the thumbnail.
function CloseButton({ onClose, file, template = 1 }) {
  if (!onClose) return null;

  const style =
    template === 2
      ? { padding: 0, flexShrink: 0 }
      : { ...closeButtonStyle, ...closeButtonWebExtra };

  return (
    <MCButton
      iconname={BASE_ICONS.CLOSE}
      width={20}
      padding={15}
      dark
      circle
      onClick={() => onClose(file)}
      style={style}
    />
  );
}

export default CloseButton;
